import React, { useEffect } from 'react';
import useSeo from '../../../hooks/cms/useSeo';
import { SeoEntityType } from '../../../types/cms/seoData';
import { Helmet } from 'react-helmet';
import { platformName } from '../../../constants';

type SeoDetailsProps = {
    type: SeoEntityType;
    slug: string;
};

export const SeoDetails = ({ type, slug }: SeoDetailsProps) => {
    const { userSeoDetails, userLoadSeoDetails } = useSeo();

    useEffect(() => {
        userLoadSeoDetails(type, slug);
    }, []);

    return (
        userSeoDetails && (
            <Helmet>
                <title>
                    {userSeoDetails.seoTitle} | {platformName.toUpperCase()}
                </title>
                <meta name='og:title' content={userSeoDetails.seoTitle} />
                <meta name='description' content={userSeoDetails.seoDescription} />
                <meta name='og:description' content={userSeoDetails.seoDescription} />
                <meta name='keywords' content={userSeoDetails.seoKeywords} />
                <meta property='og:url' content={window.location.href} />
            </Helmet>
        )
    );
};
